
export default {
  props: {
    members: {
      type: Array,
      default() {
        return [
          {
            slug: 'klaus-bar',
            title: 'Klaus Walti',
            job_title: 'Geschäftsführer',
            phone: '079 654 86 48',
            email: 'klaus.bar@atramex.ch',
            departments: [{ title: 'Inhaber', slug: 'inhaber' }],
            image: {
              url: require('~/assets/img/placeholders/person.jpg'),
              alt: 'Person Platzhalter',
            },
          },
          {
            slug: 'klaus-walti',
            title: 'Klaus Walti',
            job_title: 'Inhaber',
            phone: '079 654 86 48',
            email: 'klaus.walti@atramex.ch',
            departments: [
              { title: 'Inhaber', slug: 'inhaber' },
              { title: 'Administration', slug: 'administration' },
            ],

            image: {
              url: require('~/assets/img/placeholders/person.jpg'),
              alt: 'Person Platzhalter',
            },
          },
        ]
      },
    },
  },

  data() {
    return {
      activeDepartments: [],
    }
  },

  computed: {
    uniqueDepartments() {
      const departments = this.members.flatMap((member) => member.departments)

      const uniqueDepartmentSlugs = [...new Set(departments.map((d) => d.slug))]

      return uniqueDepartmentSlugs.map((departmentSlug) => {
        const department = departments.find((d) => d.slug === departmentSlug)

        department.active = this.activeDepartments.includes(department)

        return department
      })
    },

    activeMembers() {
      if (this.activeDepartments.length === 0) return this.members

      return this.members.filter((member) => {
        for (const department of member.departments) {
          if (this.activeDepartments.find((d) => d.slug === department.slug)) {
            return true
          }
        }

        return false
      })
    },
  },

  methods: {
    toggle(filter) {
      if (this.activeDepartments.includes(filter)) {
        this.activeDepartments = this.activeDepartments.filter(
          (activeFilter) => activeFilter.slug !== filter.slug
        )
      } else {
        this.activeDepartments.push(filter)
      }
    },
  },
}
